import React, { useEffect, useState } from "react";
import TrackCard from "../reservations/components/subcompdash/TrackCard";
// import { firestore } from '../firebase';

const Tracking = () => {
    const [datas] = useState([]);
    const [available] = useState([]);
    const [resToday] = useState({});
    const [leavingToday, setLeavingToday] = useState([]);
    const [returningToday] = useState(0);

    // console.log(datas.length);

    useEffect(() => {
        const today = new Date();
        const week = new Date();
        week.setDate(today.getDate() + 1);
        // console.log(week.getDate());
        // const date1 = new Date(week.setHours(0, 0, 0, 0));
        // const date2 = new Date(week.setHours(23, 59, 59, 59));

        // firestore
        //    .collection('Reservations')
        //    .orderBy('pickupDate')
        //    .where('pickupDate', '>=', date1)
        //    .where('pickupDate', '<=', date2)
        //    .onSnapshot((snapshot) => {
        //      const postData = [];
        //      snapshot.forEach((doc) => {
        //        //   if (
        //        //     doc.data().isApproved &&
        //        //     doc.data().isCarSelected &&
        //        //     !doc.data().isCarPickedUp
        //        //   )
        //        postData.push({ ...doc.data(), id: doc.id });
        //      });
        //   setDatas(postData);
    }, []);

    useEffect(() => {
        const today = new Date();
        const week = new Date();
        week.setDate(today.getDate());
        // console.log(week.getDate());
        const date1 = new Date(week.setHours(0, 0, 0, 0));
        const date2 = new Date(week.setHours(23, 59, 59, 59));

        if (datas) {
            datas.forEach((data) => {
                if (data.pickupDate >= date1 && data.pickupDate <= date2) {
                    setLeavingToday((prev) => [...prev, data]);
                }

                //  firestore
                //    .collection("Reservations")
                //    .orderBy("pickupDate")
                //    .where("pickupDate", ">=", date1)
                //    .where("pickupDate", "<=", date2)
                //    .onSnapshot((snapshot) => {
                //      const postData = [];
                //      snapshot.forEach((doc) => {
                //        //   if (
                //        //     doc.data().isApproved &&
                //        //     doc.data().isCarSelected &&
                //        //     !doc.data().isCarPickedUp
                //        //   )
                //        postData.push({ ...doc.data(), id: doc.id });
                //      });
                //   setLeavingToday(postData);
            });
        }
    }, [datas]);

    useEffect(() => {
        // firestore.collection('Stat').onSnapshot((snapshot) => {
        //     const postData = [];
        //     // setUsers([]);
        //     snapshot.forEach((doc) => {
        //         setAvailibility((prev) => [...prev, doc.data()]);
        //         postData.push({ ...doc.data(), id: doc.id });
        //     });
        //     setAvailable(postData[0]);
        // }), [];
    }, []);

    useEffect(() => {
        // const dd = new Date();
        // const mm = dd.getMonth() + 1;
        // const month = mm.toString();
        // const date = dd.getDate().toString();
        // firestore
        //    .collection('Stat')
        //    .doc('Reservations')
        //    .collection(year)
        //    .doc(month)
        //    .onSnapshot((snapshot) => {
        //        if (snapshot.data()) {
        //            setResToday(snapshot.data()[date]);
        //        }
        //    });
    }, []);

    useEffect(() => {
        const today = new Date();
        const week = new Date();
        week.setDate(today.getDate());
        // console.log(week.getDate());
        // const date1 = new Date(week.setHours(0, 0, 0, 0));
        // const date2 = new Date(week.setHours(23, 59, 59, 59));
        // firestore
        //    .collection('Reservations')
        //    .orderBy('dropOffDate')
        //    .where('dropOffDate', '>=', date1)
        //    .where('dropOffDate', '<=', date2)
        //    .onSnapshot((snapshot) => {
        //        const postData = [];
        //        snapshot.forEach((doc) => {
        //            //   if (
        //            //     doc.data().isApproved &&
        //            //     doc.data().isCarSelected &&
        //            //     !doc.data().isCarPickedUp
        //            //   )
        //            postData.push({ ...doc.data(), id: doc.id });
        //        });
        //        setReturningToday(postData.length);
        //    });
    }, []);

    return (
        <>
            <div className="active-link min-h-0 flex-1">
                    <div>
                        <div
                            className="text-[1.2rem] fontbold"
                            style={{
                                paddingBottom: "0.7rem",
                            }}>
                            Tracking
                        </div>
                    </div>
                    <div className="grid grid-cols-4 gap-5">
                        {/* <TrackCard
                     number={"01"}
                     name={"INFLEET"}
                     link={"https://google.com/"}
                  /> */}
                        <TrackCard
                            number={`${available?.available < 10 ? 0 : ""}${
                                available?.available ? available?.available : 0
                            }`}
                            name={"AVAILABLE"}
                        />

                        {/* <TrackCard number={"03"} name={"ON RENT"} />
                  <TrackCard number={"04"} name={"RETURNED"} /> */}
                        {/* <TrackCard number={"05"} name={"OVERDUE"} /> */}
                        <TrackCard number={`0${resToday?.total ? resToday?.total : 0}`} name={"RENTED TODAY"} />
                        <TrackCard
                            number={`0${datas?.length ? datas?.length : 0}`}
                            name={"RESERVATIONS TOMORROW"}
                            page={"/track/reservation-tomorrow"}
                        />
                        {/* <TrackCard number={"08"} name={"NO SHOW"} /> */}
                        <TrackCard
                            number={`0${leavingToday?.length ? leavingToday?.length : 0}`}
                            name={"LEAVING TODAY"}
                            page={"/track/leaving-today"}
                        />
                        <TrackCard
                            number={`0${returningToday?.length ? returningToday?.length : 0}`}
                            name={"RETURNING TODAY"}
                            page={"/track/returning-today"}
                        />
                        {/* <TrackCard number={"10"} name={"WALKING"} /> */}
                    </div>
                </div>
        </>
    );
};

export default Tracking;
